import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/currency';

const TopCustomersCard = ({ customers = [], currency = 'USD' }) => {
  const navigate = useNavigate();

  const formatAmount = (amount) => {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount || 0);
    } catch (error) {
      return formatCurrency(amount || 0);
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl text-foreground">
          Top Customers
        </h2>
        <button 
          onClick={() => navigate('/customer-management')}
          className="caption text-primary hover:text-primary/80 transition-smooth"
        >
          View All
        </button>
      </div>

      {customers.length > 0 ? (
        <div className="space-y-3">
          {customers.slice(0, 5).map((customer, index) => (
            <button
              key={customer.id}
              onClick={() => navigate('/customer-management')}
              className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-muted transition-smooth hover-lift active-press text-left"
            >
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <span className="font-semibold text-primary text-sm">
                  #{index + 1}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-body font-medium text-sm text-foreground mb-1 truncate">
                  {customer.company_name}
                </h3>
                <p className="caption text-muted-foreground truncate">
                  {customer.contact_person}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="font-body font-semibold text-sm text-foreground">
                  {formatAmount(customer.period_total_invoiced)}
                </p>
                <p className="caption text-muted-foreground">
                  {customer.period_invoice_count} invoice{customer.period_invoice_count !== 1 ? 's' : ''}
                </p>
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <Icon name="Users" size={32} className="text-muted-foreground mx-auto mb-2" />
          <p className="text-muted-foreground">No customer data available</p>
        </div>
      )}
    </div>
  );
};

export default TopCustomersCard;
